var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1,
    id: "_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.9,322H299.14a15,15,0,0,1,0-30H354.9a70.13,70.13,0,0,0,0-140.25c-1.89,0-3.9.09-6.14.29a15,15,0,0,1-14.25-7.42,98.17,98.17,0,0,0-181.68,32.6,15,15,0,0,1-15.35,12.47l-1.06,0a51.17,51.17,0,1,0,0,102.34h74.71a15,15,0,0,1,0,30H136.42a81.18,81.18,0,0,1-10.56-161.66,128.17,128.17,0,0,1,229.67-38.59A100.13,100.13,0,0,1,354.9,322Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,425a15,15,0,0,1-10.6-4.4l-48.18-48.17a15,15,0,1,1,21.21-21.22l37.57,37.58,37.58-37.58a15,15,0,0,1,21.21,21.22L265.74,420.6A15,15,0,0,1,255.13,425Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,425a15,15,0,0,1-15-15V245.24a15,15,0,0,1,30,0V410A15,15,0,0,1,255.13,425Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.036186f212ae24cdfc345a1c93321d45.svg";
export { ForwardRef as ReactComponent };